module.exports = __webpack_public_path__ + "img/flygtninge01.270c6e9e.jpeg";